import React from 'react';
import SEO from '../components/SEO';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FloatingWhatsApp from '../components/FloatingWhatsApp';
import Hero from '../components/sections/Hero';
import About from '../components/sections/About';
import Subjects from '../components/sections/Subjects';
import WhyChoose from '../components/sections/WhyChoose';
import GradesAndBoards from '../components/sections/GradesAndBoards';
import Locations from '../components/sections/Locations';
import content from '../data/content.json';

const Home = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <SEO
        title={content.seo.home.title}
        description={content.seo.home.description}
        keywords={content.seo.home.keywords}
      />
      <Header />
      <main>
        <Hero />
        <GradesAndBoards />
        <About />
        <Subjects />
        <Locations />
        <WhyChoose />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};

export default Home;
